import { toast } from '@/shared/toast'

export const copyToClipboard = (title: string, content: string) => {
  navigator.clipboard.writeText(content)
  toast.info(`${title} copied to clipboard`)
}

export const getFilesFromClipboardEvent = (event: ClipboardEvent): [File, ...File[]] | null => {
  const clipboardData = event.clipboardData
  if (!clipboardData) {
    return null
  }

  const files = Array.from(clipboardData.files)
  const firstFile = files.at(0)
  if (!firstFile) {
    return null
  }

  /**
   * This seems like a fairly weird way to build the list of files. But we want to
   * make sure that consumers of this function know that when it returns an array,
   * there is always at least one file. This is so that they can fall back to the
   * browser's default paste handler if there are no files.
   */
  return [firstFile, ...files.slice(1)]
}
